import { api } from '@/lib/api';
import type { IApiResponse, IScript, IScriptExecutionResult } from '@skystone/shared';

export const scriptApi = {
  getScripts: async (): Promise<IScript[]> => {
    const res = await api.get<IApiResponse<IScript[]>>('/scripts');
    return res.data;
  },

  execute: async (
    scriptId: string,
    parameters?: Record<string, string>
  ): Promise<IScriptExecutionResult> => {
    const res = await api.post<IApiResponse<IScriptExecutionResult>>('/scripts/execute', {
      scriptId,
      parameters,
    });
    return res.data;
  },
};
